import PropTypes from 'prop-types';
import styled from '@happymoneyinc/styled-components';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx } from 'react/jsx-runtime';

const Link = props => {
  const {
    children,
    className,
    element,
    external,
    onClick,
    testID,
    url,
    disabled
  } = props;
  const handleClick = e => {
    if (onClick) {
      onClick();
      e.preventDefault();
    }
  };
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsx(StyledElement, {
      as: element,
      className: `${className} ho-anchor`,
      href: element === 'a' ? url : null,
      onClick: e => handleClick(e),
      target: external ? '_blank' : null,
      "data-testid": `${testID}-${element}`,
      $disabled: disabled,
      children: children
    })
  });
};
const StyledElement = styled.a`
  color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.systemLink;
}};
  font-family: inherit;
  font-size: inherit;
  text-decoration: underline;
  background: none;
  border: none;

  ${_ref2 => {
  let {
    $disabled
  } = _ref2;
  return $disabled && 'pointer-events: none;';
}}

  &:hover, &:focus {
    color: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.systemLinkHover;
}};
    cursor: pointer;
  }

  &:active {
    color: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.systemLinkActive;
}};
  }
`;
Link.defaultProps = {
  children: null,
  className: '',
  element: 'a',
  external: false,
  onClick: null,
  testID: 'link',
  url: '',
  disabled: false
};
Link.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  element: PropTypes.string,
  external: PropTypes.bool,
  onClick: PropTypes.func,
  testID: PropTypes.string,
  url: PropTypes.string,
  disabled: PropTypes.bool
};
var Link$1 = Link;

export { Link$1 as default };
//# sourceMappingURL=Link.js.map
